import React from 'react';
import { Link } from 'react-router-dom';

export default function OrderSuccess() {
  const params = new URLSearchParams(window.location.search);
  const orderNo = params.get('order') || '';

  return (
    <div className="bg-bg-primary min-h-screen flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="w-20 h-20 rounded-full bg-green-500/20 flex items-center justify-center mx-auto">
          <span className="text-4xl">✓</span>
        </div>
        <h1 className="text-3xl font-black text-white">Ödeme Başarılı!</h1>
        {orderNo && (
          <p className="text-text-muted">Sipariş No: <span className="text-accent-gold font-bold">{orderNo}</span></p>
        )}
        <p className="text-text-muted">Siparişiniz alındı. En kısa sürede sizinle iletişime geçeceğiz.</p>
        <Link
          to="/urunler"
          className="inline-block bg-accent-red text-white font-bold px-8 py-3 rounded-xl hover:bg-red-700 transition"
        >
          Alışverişe Devam Et
        </Link>
      </div>
    </div>
  );
}
